var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgViewChart = function SvgViewChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.375 37.827H10.173V5.625H5.625v36.75h36.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.089 31.629a4.139 4.139 0 1 0 0-8.278 4.139 4.139 0 0 0 0 8.278M17.506 20.345a4.139 4.139 0 1 0 0-8.278 4.139 4.139 0 0 0 0 8.278m19.853-5.743a4.14 4.14 0 1 0 0-8.278 4.14 4.14 0 0 0 0 8.278"
  })))));
};
export default SvgViewChart;